<template>
    <EditModal
        :id="id"
        title="Administrator benachrichtigen"
        size="lg"
        buttonText="Senden"
        scrollable
        :busy="busy"
        @ok="dataSend"
        @hide="dataReset"
    >
        <b-textarea v-model="message" placeholder="Ihre Nachricht..."></b-textarea>
    </EditModal>
</template>

<script>
import { ApiFactory } from "@/api/ApiFactory";
import Toaster from "@/mixins/Toaster/Toaster";
import EditModal from "@/components/EditModal/EditModal";

const MaintenanceApi = ApiFactory.get("maintenance");

export default {
    name: "AdminMessage",
    components: {
        EditModal
    },
    mixins: [Toaster],
    data() {
        return {
            id: "adminMessage",
            busy: false,
            message: ""
        };
    },
    methods: {
        async dataSend(evt) {
            evt.preventDefault();
            this.busy = true;
            const response = await MaintenanceApi.postAdminMessage({
                message: this.message
            });
            if (response.ok) {
                this.makeToast(
                    "Erfolgreich versendet",
                    "Die Nachricht ist erfolgreich an den Administrator versendet worden"
                );
                this.$root.$emit("bv::hide::modal", this.id);
            }
            this.busy = false;
        },
        dataReset() {
            this.message = "";
        }
    }
};
</script>